const notifyIntercomOfPageChange = (location, action) => {
  window.Intercom("update");
};

export const setupIntercomNotifier = history => {
  if (window.Intercom) {
    history.listen(notifyIntercomOfPageChange);
  }
};
